module.exports = __webpack_public_path__ + "static/media/files.ebdbbf9c.svg";